module.exports = __webpack_public_path__ + "static/media/google-3-scan.bf0146bc.png";